import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';

interface BrandsBannerProps {}

export const BrandsBanner: React.FC<BrandsBannerProps> = () => (
    <Stack
        alignItems="center"
        direction={{ default: 'column', lg: 'row' }}
        borderColor="grey_400"
        justifyContent="spaceBetween"
        borderWidth="sm"
        borderRadius="lg"
        gap="0"
        paddingY="0"
        paddingLeft={{ default: '0', lg: '10' }}
        marginTop={{ default: '10', sm: '10', md: '16', lg: '16', xl: '16' }}
        marginBottom={{ default: '10', sm: '10', md: '16', lg: '16', xl: '16' }}
    >
        <Typography
            color="grey_900"
            size={{ default: 'b_sm', sm: 'h_xxs', lg: 'h_xs' }}
            fontWeight="bold"
            whiteSpace="nowrap"
        >
            <I18n k="skill_page_perseus.brands_banner.title" />
        </Typography>
        {/* XS pic */}
        <Container paddingY="4" display={{ default: 'block', sm: 'none' }} width={{ default: '100%', lg: '85%' }}>
            <Image
                src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/09b190d2b2a1ee2fb6ebfa27acc971ec-1712326833080/Frame%201410082180%20%283%29.png"
                display="block"
                height="100%"
                objectFit="contain"
                alt="123"
            />
        </Container>
        {/* SM pic */}
        <Container
            paddingY="4"
            display={{ default: 'none', sm: 'block', lg: 'none' }}
            width={{ default: '100%', lg: '85%' }}
        >
            <Image
                src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1584930dd72ab1bc0538856a8865ee2b-1712326440293/Frame%201410082180%20%282%29.png"
                display="block"
                height="100%"
                objectFit="contain"
                alt="123"
            />
        </Container>
        {/* LG+ pic */}
        <Container paddingY="4" display={{ default: 'none', lg: 'block' }} width={{ default: '100%', lg: '85%' }}>
            <Image
                src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/45bbcb11d744bca8457063abf71bd81f-1712322646886/trusted_by.png"
                display="block"
                height="100%"
                objectFit="contain"
                alt="123"
            />
        </Container>
    </Stack>
);
